import { render } from "./SmallTitle.vue?vue&type=template&id=1c5ae16e"
import script from "./SmallTitle.vue?vue&type=script&lang=js"
export * from "./SmallTitle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__